import { UserType } from '../actions/ActionType';

const initialState = {
  message: '',
  userInfo: false,
  users: [],
  doctors: [],
  business: [],
  businessData: [],
  translations: false,
  currentLanguage: 'en',
  businessInfo: false,
  notifications: [],
  masterDrug: []
};

const getUser = (state, action) => {
  const newState = {};
  Object.assign(newState, state, { userInfo: action.payload, currentLanguage: action.payload.preferredLanguage });
  return newState;
};

const getBusiness = (state, action) => {
  const businessData = action.payload.map((data) => {
    return { label: data.businessName, value: data.businessId }
  })
  const newState = {};
  Object.assign(newState, state, { business: businessData, businessData: action.payload });
  return newState;
};

const getBusinessInfo = (state, action) => {
  const newState = {};
  Object.assign(newState, state, { businessInfo: action.payload });
  return newState;
};

const getAllUsers = (state, action) => {
  const newState = {};
  Object.assign(newState, state, { users: action.payload });
  return newState;
};

const getAllDoctors = (state, action) => {
  const newState = {};
  Object.assign(newState, state, { doctors: action.payload });
  return newState;
};

const getTranslations = (state, action) => {
  const newState = {};
  Object.assign(newState, state, { translations: action.payload, currentLanguage: state.currentLanguage });
  return newState;
};

const changeLanguage = (state, action) => {
  const newState = {};
  Object.assign(newState, state, { currentLanguage: action.payload });
  return newState;
};

const getNotifications = (state, action) => {
  const newState = {};
  Object.assign(newState, state, { notifications: action.payload });
  return newState;
};

const getMasterDrug = (state, action) => {
  const newState = {};
  Object.assign(newState, state, { masterDrug: action.payload });
  return newState;
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case UserType.GET_USER: {
      return getUser(state, action);
    }
    case UserType.GET_BUSINESS: {
      return getBusiness(state, action);
    }
    case UserType.GET_BUSINESS_INFO: {
      return getBusinessInfo(state, action);
    }
    case UserType.GET_ALL_USERS: {
      return getAllUsers(state, action);
    }
    case UserType.GET_ALL_DOCTORS: {
      return getAllDoctors(state, action);
    }
    case UserType.GET_TRANSLATION: {
      return getTranslations(state, action);
    }
    case UserType.CHANGE_LANGUAGE: {
      return changeLanguage(state, action);
    }
    case UserType.GET_NOTIFICATIONS: {
      return getNotifications(state, action);
    }
    case UserType.GET_MASTER_DRUG: {
      return getMasterDrug(state, action);
    }
    default: {
      return state;
    }
  }
}


// WEBPACK FOOTER //
// ./reducers/UserReducer.js